import { StoreAttributes } from '@pylot-data/hooks/product/graphql/Fragments/StoreAttributes'
export const GET_PRODUCTS_BY_SKU_QUERY = /* GraphQL */ `
    query getProductsBySku($skus: [String]) {
        products(filter: { sku: { in: $skus } }) {
            items {
                __typename
                id
                name
                product_eyebrow_badge
                product_eyebrow_badge_text
                sku
                brand
                brand_text
                subtitle
                stock_status
                addtocart_popup_cms
                ${StoreAttributes}
                small_image {
                    url
                }
                url_key
                mp_label_data {
                    priority
                    label_template
                    label_image
                    same
                    list_template
                    list_image
                }
                short_description {
                    html
                }
                price_range {
                    __typename
                    minimum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                    maximum_price {
                        final_price {
                            value
                            currency
                        }
                    }
                }
                special_price
                categories {
                    __typename
                    name
                    url_path
                    breadcrumbs {
                        __typename
                        category_uid
                        category_name
                        category_url_path
                    }
                }
            }
            total_count
            aggregations {
                attribute_code
                count
                label
                options {
                    label
                    value
                    count
                }
            }
        }
    }
`
